import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { QuoteClientInfoDispatcher } from "./Variable";

export interface QuoteClientInfoStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class QuoteClientInfoStatic extends BaseStore<QuoteClientInfoStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(QuoteClientInfoDispatcher, (actionData) => this.onQuoteClientInfoStoreResponse(actionData));
    }

    public getLastResult(): QuoteClientInfoStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): QuoteClientInfoStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onQuoteClientInfoStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
                case ActionType.Update:
                    this.setState({ actionType: actionData.actionType, data: actionData.payload });
                    break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
